import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { param } from "jquery";

@Component({
  selector: 'check-icon-cell',
  templateUrl: './check-icon-renderer.component.html',
  standalone: true,
  imports: []
})

export class CheckIconRendererComponent implements ICellRendererAngularComp {

  showCheckIcon: boolean;
  icon: string;
  constructor() { }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.showCheckIcon = params.getValue();
      this.icon = params.colDef.cellRendererParams?.icon || '/assets/svg-icons/icons/check.svg';
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
